














































import { Component, Vue } from 'vue-property-decorator'
import packageInfo from '../../package.json'
import { getNavObj, LANG } from '../nav/'
import { getTheme } from '../utils'

@Component({})
export default class Navbar extends Vue {
  hide = false
  name = packageInfo.name
  version = packageInfo.version
  homePageUrl = packageInfo.homepage
  theme = getTheme() || 'default'

  get nextLanguage() {
    return this.$route.meta?.lang === LANG.ENGLISH ? '🇨🇳' : '🇺🇸'
  }

  get navObj() {
    return getNavObj(this.$route.meta?.lang)
  }

  mounted() {
    this.hide = document.body.clientWidth < 992
  }

  switchLanguage() {
    this.$router.push({
      path: (
        this.$route.meta?.lang === LANG.ENGLISH ? LANG.ZH_CN : LANG.ENGLISH
      ) + this.$route.meta?.route
    })
  }

  changeTheme(e: Event) {
    const theme = (e.target as any).value
    localStorage.setItem('theme', theme)
    location.reload()
  }

  routeClickHandle() {
    if (document.body.clientWidth < 992) {
      this.hide = true
    }
  }
}
